export default __webpack_public_path__ + "static/media/right_arrow_orange.ee3e80cd.svg";